{
  "error": "Chyba",
  "help": "Nápověda",
  "info": "Informace",
  "success": "Úspěch",
  "warning": "Upozornění"
}
